import {useContext} from "react"
import { CreateReferantContext } from "./context"

export function useCreateReferantHook() {
    return useContext(CreateReferantContext);
}